import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";

const CookieBanner = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Check if the cookie policy has been accepted
    if (!localStorage.getItem("cookiePolicyAccepted")) {
      setShow(true);
    }
  }, []);

  const handleAccept = () => {
    // Save user acceptance to localStorage
    localStorage.setItem("cookiePolicyAccepted", "true");
    setShow(false);
  };

  if (!show) {
    return null;
  }

  return (
    <div
      className="position-fixed bottom-0 start-0 w-100  py-2"
      style={{
        zIndex: "6",
        backgroundColor: "rgba(255, 255, 255, 0.47)",
          // "color-mix(in srgb, var(--Mindox-blue) 60%, transparent)",
        backdropFilter: "blur(18px)",
      }}
    >
      <div style={{fontSize:"0.8rem"}} className="d-flex flex-row justify-content-center align-items-center">
        <div className="px-2">
          <span>
            We use cookies to improve your experience. By using our site, you
            agree to our{" "}
            <a
              className="fw-bold text-decoration-underline text-reset text-light"
              href="/privacy-policy"
            >
              Privacy & Cookie Policy
            </a>
            .
          </span>
        </div>
        <div className="px-2">
          <Button style={{fontSize:"0.8rem"}}  variant="dark" size="sm" onClick={handleAccept}>
            Dismiss
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
